import * as React from "react";

import Box from "@mui/material/Box";
import TabPanel from "../../../../../../../components/Tabs/TabPanel.component";
import SimpleTab from "../../../../../../../components/Tabs/SimpleTab";

import HeadPanel from "./Panels/HeadPanel";
import ShellPanel from "./Panels/ShellPanel";
import PipePanel from "./Panels/PipePanel";
import FlangePanel from "./Panels/FlangePanel";
import PadPanel from "./Panels/PadPanel";

const modelingTabs = [
  { label: "Head", panel: <HeadPanel /> },
  { label: "Shell", panel: <ShellPanel /> },
  { label: "Pipe", panel: <PipePanel /> },
  { label: "FLange", panel: <FlangePanel /> },
  { label: "Pad", panel: <PadPanel /> },
];

export default function SpecTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <SimpleTab
          tabs={modelingTabs.map((t) => t.label)}
          value={value}
          setValue={setValue}
          sx={{ fontSize: 16 }}
        />
      </Box>

      {modelingTabs.map((t, i) => {
        return (
          <TabPanel value={value} index={i} key={t.label}>
            {t.panel}
          </TabPanel>
        );
      })}
    </Box>
  );
}
